import * as React from 'react';
import moment from 'moment';
import RadioButtonList, { RadioButtonListItem } from "components/RadioButtonList";
import { DatePickerContainer, DateLabel, ButtonContainer, PresetContainer } from './style';
import { DateRangePicker } from 'react-dates';
import * as _ from 'lodash';
import { TCButton } from 'components/TCButton';
import { TC_BUTTON_TYPE } from 'components/TCButton/constants';

export enum DatePickerLabelPosition {
    ABOVE = 'ABOVE',
    CONTAINED_LEFT = 'CONTAINED_LEFT',
}

export interface DatePickerProps {
    dateFormat?: string;
    comparisonStyles?: boolean;
    comparisonPeriod?: any;
    startDate: moment.Moment;
    endDate: moment.Moment;
    highlightedStartDate?: moment.Moment;
    highlightedEndDate?: moment.Moment;
    onDatesChange: (dates: { startDate: moment.Moment, endDate: moment.Moment }) => void;
    label?: string;
    noBlockedDays?: boolean;
}

export interface DatePickerState {
    focusedInput?: any;
    endDate: moment.Moment,
    startDate: moment.Moment
    comparisonPeriod?: any;
    presetsIndex?: number;
}

const today = moment();
const presets = [
    {
        text: "Today",
        start: moment().subtract(1, 'days'),
        end: today,
    },
     {
        text: "This week",
        start: moment().subtract(6, 'days'),
        end: today,
    },
    {
        text: "This month",
        start: moment().startOf('month'),
        end: today,
    },
    {
        text: "Last month",
        start: moment().subtract(1, 'month').startOf('month'),
        end: moment().subtract(1, 'months').endOf('month'),
    },
    {
        text: "Last 90 days",
        start: moment().subtract(90, 'days'),
        end: today,
    }
];





export default class DatePicker extends React.Component<DatePickerProps, DatePickerState> {

    constructor(props: DatePickerProps) {
        super(props)

        this.state = {
            focusedInput: undefined,
            startDate: props.startDate.clone(),
            endDate: props.endDate.clone(),
            presetsIndex: -1
        }

        this.onDatesChange = this.onDatesChange.bind(this)
        this.onDateSelectionFocusChange = this.onDateSelectionFocusChange.bind(this)
        this.comparisonPeriod = this.comparisonPeriod.bind(this);
        this.isDayHighlighted = this.isDayHighlighted.bind(this);
        this.isDayBlocked = this.isDayBlocked.bind(this)
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.startDate, this.props.startDate)
            ||!_.isEqual(prevProps.endDate, this.props.endDate) 
        ) {
            this.setState({
                startDate: this.props.startDate,
                endDate: this.props.endDate,
            })
        }
    }

    onDateSelectionFocusChange(focusedInput) {
        if (focusedInput) {
            this.setState({
                focusedInput
            });
        } else {
            this.setState({
                focusedInput
            }, () => {
                if (this.state.startDate && this.state.endDate) {
                    this.props.onDatesChange({
                        startDate: this.state.startDate.clone(),
                        endDate: this.state.endDate.clone()
                    });
                }
            });
        }
    }


    highlightToday = day => day.startOf('day').isSame(Date());

    onDatesChange(dateRange) {
        this.setState({
            endDate: dateRange.endDate,
            startDate: dateRange.startDate
        });
    };

    comparisonPeriod() {

    }

    isDayBlocked(day) {
        if (this.props.noBlockedDays) return;
        return day.isAfter(moment(), 'day');
    }

    isDayHighlighted(day) {
        return day.isSameOrAfter(this.props.highlightedStartDate, 'day') && day.isSameOrBefore(this.props.highlightedEndDate, 'day');
    }
    
    renderDatePresets() {

        let itemList: RadioButtonListItem[] = presets.map(({ text, start, end }, index) => {
                    return (
                        {
                            id: `${index}`,
                            name:text,
                            enable: true,
                            itemMessage:""
                        }
                    );
                });
        
        return <PresetContainer>
                    <RadioButtonList 
                        name="rblLocations" 
                        RadioButtonListItems = {itemList}
                        onSelectedItem = {(selectedValue) => this.setState({ presetsIndex: selectedValue})} 
                        radioOptionsStyle={{display: "flex", fontSize: "14px", fontWeight: "normal", flexWrap: "wrap"}}
                        radioOptionStyle={{width: "33%", marginBottom: "20px"}}
                        selected={`${this.state.presetsIndex}`}
                    />
                    <ButtonContainer>
                        <TCButton
                            type={TC_BUTTON_TYPE.PRIMARY}
                            onClick={() => {
                                if (this.state.presetsIndex && presets[this.state.presetsIndex]) {
                                    this.onDateSelectionFocusChange(null);
                                    this.onDatesChange({ startDate: presets[this.state.presetsIndex].start, endDate: presets[this.state.presetsIndex].end });
                                }
                            }}
                        >
                            Apply
                        </TCButton>
                    </ButtonContainer>
                </PresetContainer>;
    }

    render() {
        return (
            <DatePickerContainer comparisonStyles={this.props.comparisonStyles}>
                {this.props.label &&
                    <DateLabel> {this.props.label} </DateLabel>
                }
                <DateRangePicker
                    displayFormat={this.props.dateFormat}
                    minimumNights={0}
                    startDate={this.state.startDate}
                    endDateId={this.props.comparisonStyles ? 'comp_end_date_id' : 'view_end_date_id'}
                    startDateId={this.props.comparisonStyles ? 'comp_start_date_id' : 'view_start_date_id'}
                    endDate={this.state.endDate}
                    onDatesChange={this.onDatesChange}
                    focusedInput={this.state.focusedInput}
                    isDayBlocked={this.isDayBlocked}
                    isOutsideRange={day => false}
                    isDayHighlighted={this.isDayHighlighted}
                    onFocusChange={this.onDateSelectionFocusChange}
                    small={true}
                    hideKeyboardShortcutsPanel={true}
                    showDefaultInputIcon={false}
                    //customArrowIcon={DATEPICKER_TEXT.LABEL_ARROWICON()}
                    inputIconPosition="after"
                    readOnly={true}
                    renderCalendarInfo={() => this.renderDatePresets()}
                />
            </DatePickerContainer>
        );
    }
}
